import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-arrow-white",
  "use": "default-arrow-white-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"default-arrow-white\"><path fill=\"#FFF\" d=\"M9.455 8L1.393 0 0 1.382l6.668 6.617L0 14.618 1.393 16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol